import { Divider } from "@heroui/react";
import { Helmet } from "react-helmet";
import { IconBuilder } from "/app/src/components/icons/IconBuilder";
import { useTranslation, Trans } from "react-i18next";
import { useStatusContext } from "/app/src/contexts/hooks/useStatusContext";
import UpdateLicenseForm from "./updateLicenseForm";
import Box from "/app/src/components/generic/components/box";
import { useCallback } from "react";

/**
 *
 * @returns Update License form header
 */
export default function UpdateLicenseFormHeader() {
  const { t } = useTranslation();

  const { licenseExpiry, message } = useStatusContext();

  const getLicenseDescription = useCallback(() => {
    if (message === "locked") {
      return (
        <div className="flex flex-col">
          <p className="font-archivo text-[14px] text-[#475467]">
            {t("translation:trial_expiry_description")} {licenseExpiry}.
          </p>
          <p className="mb-0 font-archivo text-[14px] text-[#475467]">
            <Trans
              i18nKey="trial_expiry_cta"
              values={{ email: "sales@itempath.com" }}
              components={{
                email: (
                  <a
                    className="no-underline font-archivo"
                    href="mailto:sales@itempath.com"
                  >
                    sales@itempath.com
                  </a>
                ),
              }}
            />{" "}
          </p>
        </div>
      );
    } else {
      return (
        <p className="font-archivo text-[14px] text-[#475467]">
          {t("translation:warehouse_exceeded")}
        </p>
      );
    }
  }, [licenseExpiry, message, t]);

  return (
    <div className="flex items-center justify-center min-h-[400px] h-[calc(100vh-214px)]">
      <Helmet>
        <title>{t("translation:update_license")} - ItemPath</title>
      </Helmet>

      <Box className="w-[756px]">
        <div className="flex flex-col">
          <div className="flex items-center space-x-2 mb-2">
            <IconBuilder icon="Warning" color="#a65900" size={20} />
            <h1 className="mb-0 text-[18px] font-medium font-archivo">
              {t("translation:update_your_license")}
            </h1>
          </div>
          <div>{getLicenseDescription()}</div>
          <Divider className="my-6" />
          <UpdateLicenseForm />
        </div>
      </Box>
    </div>
  );
}
